import scope from "./scope";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_CASH_FLOW_DATA = `${scope}/REQUEST_CASH_FLOW_DATA`;
export const RECEIVE_CASH_FLOW_DATA = `${scope}/RECEIVE_CASH_FLOW_DATA`;
